'use client';

import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { AnimatePresence, m } from 'motion/react';
import { css } from 'styled-system/css';

import { IconButton } from '@shaojiang/components/ui/icon-button';
import useShaojiangTheme from '@shaojiang/hooks/useShaojiangTheme';
import { iconSwapVariants } from '@shaojiang/lib/motion';
import { ThemeMode } from '@shaojiang/theme/modes';

interface Props {
  labels: { toLight: string; toDark: string };
}

/** Light / dark toggle; the icon spins out and the next one spins in. */
export function ThemeToggle({ labels }: Props) {
  const { theme, setTheme } = useShaojiangTheme();
  const isDark = theme === ThemeMode.Dark;

  return (
    <IconButton
      variant='surface'
      size='sm'
      aria-label={isDark ? labels.toLight : labels.toDark}
      title={isDark ? labels.toLight : labels.toDark}
      onClick={() => setTheme(isDark ? ThemeMode.Light : ThemeMode.Dark)}
      // the icon is unknown until mounted (next-themes reads it from storage)
      style={{ visibility: theme ? 'visible' : 'hidden' }}
    >
      <AnimatePresence mode='wait' initial={false}>
        <m.span
          key={isDark ? 'sun' : 'moon'}
          className={css({ display: 'inline-flex' })}
          variants={iconSwapVariants}
          initial='initial'
          animate='animate'
          exit='exit'
        >
          {isDark ? <Sun /> : <Moon />}
        </m.span>
      </AnimatePresence>
    </IconButton>
  );
}
